import React from 'react';
import ProductApprovalList from '../ProductApprovalList';
import ProductListSearchBox from '../../../common/ProductListSearchBox';

const ProductApprovalListWrap = (props) => {
  const {
    productApprovalList,
    categorySelectList,
    setData,
    getList,
    getExcelDownload,
    getProductTagColumnTagList,
    getProductSubCategoryList,
  } = props;

  return (
    <div className="product-approval-list-wrap">
      {/*상품 검색 박스*/}
      <ProductListSearchBox
        setData={(data) =>
          setData({
            path: ['productList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        setTagSearchList={(list) =>
          setData({
            path: ['productList', 'tagSearchList'],
            value: list,
          })
        }
        searchData={productApprovalList.searchData}
        tagGroupList={productApprovalList.tagGroupList}
        tagList={productApprovalList.tagList}
        tagSearchList={productApprovalList.tagSearchList}
        categorySelectList={categorySelectList}
        getList={getList}
      />

      {/* 상품 승인 리스트 */}
      <ProductApprovalList
        productApprovalList={productApprovalList}
        getList={getList}
        getExcelDownload={getExcelDownload}
        getProductTagColumnTagList={getProductTagColumnTagList}
        getProductSubCategoryList={getProductSubCategoryList}
      />
    </div>
  );
};

export default ProductApprovalListWrap;
